import news1 from "../../assets/News/news1.png"
import news2 from "../../assets/News/news2.png"
import news3 from "../../assets/News/news3.png"
import news4 from "../../assets/News/news4.png"

export const news = [
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news2}`,
        heading: "Top 5 Daily Stories of 2023",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news3}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news2}`,
        heading: "Top 5 Daily Stories of 2023",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news4}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    {
        src: `${news1}`,
        heading: "Daily News",
        text: "Now and Forever is the chain of multiple gas stations across Houston, Texas."
    },
    
];